import { createClient, predicate, cookie } from "@prismicio/client";
import { asText, asHTML, asLink, asDate, asImageSrc, asImageWidthSrcSet, asImagePixelDensitySrcSet, documentToLinkField } from "@prismicio/helpers";
import { PrismicEmbed } from "./components/PrismicEmbed.js";
import { PrismicImage } from "./components/PrismicImage.js";
import { PrismicLink } from "./components/PrismicLink.js";
import { PrismicText } from "./components/PrismicText.js";
import { PrismicRichText } from "./components/PrismicRichText.js";
import { SliceZone } from "./components/SliceZone.js";
import { prismicKey } from "./injectionSymbols.js";
const createPrismic = (options) => {
  let client;
  if (options.client) {
    client = options.client;
  } else {
    client = createClient(options.endpoint, {
      fetch: async (endpoint, options2) => {
        let fetchFunction;
        if (typeof globalThis.fetch === "function") {
          fetchFunction = globalThis.fetch;
        } else {
          fetchFunction = (await import("isomorphic-unfetch")).default;
        }
        return await fetchFunction(endpoint, options2);
      },
      ...options.clientConfig
    });
  }
  const prismicClient = {
    client,
    predicate,
    cookie
  };
  const prismicHelpers = {
    asText,
    asHTML: (richTextField, linkResolver, htmlSerializer) => {
      return asHTML(richTextField, linkResolver || options.linkResolver, htmlSerializer || options.htmlSerializer);
    },
    asLink: (linkField, linkResolver) => {
      return asLink(linkField, linkResolver || options.linkResolver);
    },
    asDate,
    asImageSrc,
    asImageWidthSrcSet,
    asImagePixelDensitySrcSet,
    documentToLinkField
  };
  const prismic = {
    options,
    ...prismicClient,
    ...prismicHelpers,
    install(app) {
      app.provide(prismicKey, this);
      app.config.globalProperties.$prismic = this;
      if (options.injectComponents !== false) {
        app.component(PrismicLink.name, PrismicLink);
        app.component(PrismicEmbed.name, PrismicEmbed);
        app.component(PrismicImage.name, PrismicImage);
        app.component(PrismicText.name, PrismicText);
        app.component(PrismicRichText.name, PrismicRichText);
        app.component(SliceZone.name, SliceZone);
      }
    }
  };
  return prismic;
};
export {
  createPrismic
};
//# sourceMappingURL=createPrismic.js.map
